import gql from "graphql-tag";

export default gql`
  mutation AddParameterizationFields(
    $id: ID
    $active: Boolean
    $profileType: Int
    $genero: Int
    $nivel_educativo: Int
    $estrato: Int
    $departamento: Int
  ) {
    addParameterizationFields(
      id: $id
      active: $active
      profileType: $profileType
      genero: $genero
      nivel_educativo: $nivel_educativo
      estrato: $estrato
      departamento: $departamento
    ) {
      id
    }
  }
`;



// WEBPACK FOOTER //
// ./src/mutations/addParameterizationFields.js